// viewer.debug.js — passive seek-timing probe for the ?debug=1 overlay.
//
// Pure module: no DOM, no globals. The DOM shell in viewer.js feeds it
// `seeking` / `seeked` events with timestamps (in milliseconds, e.g. from
// performance.now()) and reads back samples()/getMedian() for display.
//
// See docs/superpowers/specs/2026-05-11-smooth-scrub-phase-a-design.md §6.

export function createSeekTimingProbe(opts = {}) {
  const maxSamples = Number.isFinite(opts.maxSamples) && opts.maxSamples > 0
    ? Math.floor(opts.maxSamples)
    : 10;
  const buf = []; // most-recent last
  let pendingSeekingAt = null;

  function onSeeking(nowMs) {
    pendingSeekingAt = Number.isFinite(nowMs) ? nowMs : null;
  }

  function onSeeked(nowMs) {
    if (pendingSeekingAt === null || !Number.isFinite(nowMs)) {
      pendingSeekingAt = null;
      return;
    }
    const delta = nowMs - pendingSeekingAt;
    pendingSeekingAt = null;
    if (delta < 0) return;
    buf.push(delta);
    if (buf.length > maxSamples) buf.splice(0, buf.length - maxSamples);
  }

  function samples() {
    return buf.slice();
  }

  function getMedian() {
    if (buf.length === 0) return 0;
    const sorted = buf.slice().sort((a, b) => a - b);
    const mid = sorted.length >> 1;
    return sorted.length % 2 === 1
      ? sorted[mid]
      : (sorted[mid - 1] + sorted[mid]) / 2;
  }

  return { onSeeking, onSeeked, samples, getMedian };
}
